module.exports = __webpack_public_path__ + "img/nopic.8d924d41.jpg";